import { render, staticRenderFns } from "./CategoryListCard.vue?vue&type=template&id=33af3cd2&scoped=true&"
import script from "./CategoryListCard.vue?vue&type=script&lang=ts&"
export * from "./CategoryListCard.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryListCard.vue?vue&type=style&index=0&id=33af3cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af3cd2",
  null
  
)

export default component.exports